import PropTypes from 'prop-types'
import { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { Menu } from '@/common/ds/Menu'
import { useMenu } from '@/common/utils/hooks/useMenu.js'
import { isInternalMenuUrl } from '@/common/utils/navigation/menu-url.js'
import { useAuthStore } from '@/common/zustand/store/auth.store.js'
import UserProfileContent from '@/common/components/user-menu/UserProfileContent.jsx'

export default function ClientesMenu({ mobileMenuOpen, mobileInitialFooterItemId, onMobileOpenChange }) {
  const { items, loading, error } = useMenu()
  const navigate = useNavigate()
  const logout = useAuthStore((state) => state.logout)

  const handleSelect = useCallback(
    (node) => {
      if (!node.url) return

      if (isInternalMenuUrl(node.url)) {
        navigate(node.url)
        onMobileOpenChange(false)
        return
      }

      window.location.href = node.url
    },
    [navigate, onMobileOpenChange]
  )

  const footerItems = useMemo(
    () => [
      {
        id: 'profile',
        label: 'Mi perfil',
        icon: 'account_circle',
        renderContent: ({ close }) => <UserProfileContent variant="mobile" showLogout={false} onClose={close} />,
        showChevron: true,
      },
      {
        id: 'notifications',
        label: 'Notificaciones',
        icon: 'notifications',
      },
      {
        id: 'help',
        label: 'Centro de ayuda',
        icon: 'help',
      },
      {
        id: 'logout',
        label: 'Cerrar sesión',
        icon: 'logout',
        onSelect: logout,
        dividerBefore: true,
      },
    ],
    [logout]
  )

  if (loading) return null

  if (error) {
    console.error('[ClientesMenu] No se pudo cargar el menú:', error)
    return null
  }

  if (items.length === 0) return null

  return (
    <Menu.Responsive
      items={items}
      onSelect={handleSelect}
      mobileOpen={mobileMenuOpen}
      mobileInitialFooterItemId={mobileInitialFooterItemId}
      onMobileOpenChange={onMobileOpenChange}
      footerItems={footerItems}
      dataTestId="clientes-main-menu"
    />
  )
}

ClientesMenu.propTypes = {
  mobileMenuOpen: PropTypes.bool.isRequired,
  mobileInitialFooterItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onMobileOpenChange: PropTypes.func.isRequired,
}
